import React, { Component } from "react";
import Header from "./Header";
import AppNavbar from "./Sidebar";
import Report from "./Report";

export default class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showComponent: false,
    };
  }

  onClickButton = (e) => {
    e.preventDefault();
    this.setState({ showComponent: true });

    alert(this.state.showComponent);
  };

  render() {
    return (
      <body data-sidebar="colored">
        <div id="layout-wrapper">
          <Header />
          <AppNavbar data={this.state} />
        </div>
        <Report />
      </body>
    );
  }
}
